import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IFormFieldSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IFormFilesUploadProps } from '.';

export const generate = (
  props?: Partial<IFormFieldSchema<IFormFilesUploadProps>>
): IFormFieldSchema<IFormFilesUploadProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.ARRAY,
    name: props?.name || id,
    title: props?.title || 'Upload',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-decorator': 'FormItem',
    'x-component': ComponentType.FormFilesUpload,
    'x-validator': [],
    'x-component-props': {
      label: 'Upload File',
      type: 'primary',
      size: 'middle',
      multiple: false,
      showUploadList: true,
      visible: true,
    },
    'x-component-props-config': {},
    'x-decorator-props': {},
    'x-decorator-props-config': {},
  };
};
